export const roadmapDataPercentage = [
    {
        percentageTitle: "1%",
        percentageSub: "(111 minted)",
        detailTitle: `Marketing Support`,
        detailSub: `Get professional marketing services for Digital Marketing, Managing Discord Servers and Social Media Accounts.`,
    },
    {
        percentageTitle: "10%",
        percentageSub: "(1111 minted)",
        detailTitle: `Airdrops & Price Rise`,
        detailSub: `Airdrop to one holder. <br> Additional airdrop to one holder who has three or more tokens. <br> The price per token rises to 0.050 ETH.`,
    },
    {
        percentageTitle: "30%",
        percentageSub: "(3333 minted)",
        detailTitle: `Airdrops & Price Rise`,
        detailSub: `Airdrops to three holders. <br> Additional airdrops to three holders who has three or more tokens. <br> The price per token rises to 0.075 ETH.`,
    },
    {
        percentageTitle: "40%",
        percentageSub: "(4444 minted)",
        detailTitle: `Initial Donation`,
        detailSub: `5% of the balance will be donated to <a href="https://malala.org/" target="_blank" rel="noreferrer noopener">Malala Fund</a>. More details <a href="#malala">here</a>`,
    },
    {
        percentageTitle: "50%",
        percentageSub: "(5555 minted)",
        detailTitle: `Airdrops & Price Rise`,
        detailSub: `Airdrops to five holders. <br> Additional airdrops to five holders who has three or more tokens. <br> The price per token rises to 0.100 ETH.`,
    },
    {
        percentageTitle: "70%",
        percentageSub: "(7777 minted)",
        detailTitle: `Airdrops & Price Rise`,
        detailSub: `Airdrops to seven holders. <br> Additional airdrops to seven holders who has three or more tokens. <br> The price per token rises to 0.125 ETH.`,
    },
    {
        percentageTitle: "80%",
        percentageSub: "(8888 minted)",
        detailTitle: `Suddenly Unicorns 3D Print Store Opens`,
        detailSub: `Token holders will be able to 3D print their tokens. This step will have more details after the costs are certain.`,
    },
    {
        percentageTitle: "90%",
        percentageSub: "(9999 minted)",
        detailTitle: `Airdrops & Price Rise`,
        detailSub: `Airdrops to nine holders. <br> Additional airdrops to nine holders who has three or more tokens. <br> The price per token rises to 0.150 ETH.`,
    },
    {
        percentageTitle: "100%",
        percentageSub: "(All minted)",
        detailTitle: `Final Raffle`,
        detailSub: `3% of the balance will be divided equally between 10 token holders. Project owners and holders with close connections will be exempted from this raffle.`,
    },
    {
        percentageTitle: "100%",
        percentageSub: "(All minted)",
        detailTitle: `Final Donation`,
        detailSub: `5% of the whole balance will be donated to <a href="https://malala.org/" target="_blank" rel="noreferrer noopener">Malala Fund</a>. More details <a href="#malala">here</a>`,
    },
    {
        percentageTitle: "100%",
        percentageSub: "(All minted)",
        detailTitle: `Future of Suddenly Unicorns`,
        detailSub: `The community will decide on the future of Suddenly Unicorns. It can be about expanding the Suddenly Unicorns Marketplace, potential DAO's, game logic with extensions, or anything.`,
    }
];

